/** @file 条件抽奖 语言配置 */
const zhCN = {
  welfareLottery: {
    copySuccess: '复制成功',
    fillInformation: '为了顺利送达奖品，我们需要您提供个人信息，请务必填写正确。',
    deadlineFillInformation: '为了顺利送达奖品，我们需要您提供个人信息，请务必填写正确。截止填写时间： <span style="color: #FF5722">{date}</span>',
    receivedInformation: '已提交信息成功!后续会有工作人员与您联系',
    deadlineTip: '您已超过填写联系信息的有效期',
    submit: '确定',
    name: '姓名',
    realName: '请输入您的真实姓名',
    phone: '手机',
    enterPhone: '请输入您的手机号码',
    wrongName: '请输入您的姓名',
    wrongPhone: '号码错误',
    countdownTip1: '还有',
    countdownTip2: '开奖',
    record: '中奖记录',
    redemptionCode: '兑换码',
    winningTime: '中奖时间',
    see: '查看',
    receive: '领取',
    winningResult: '抽奖结果',
    resultTip1: '继续观看直播，赢取更多福利吧~',
    receivePrizes: '领取奖品',
    ok: '我知道了',
    numberOfPrizes1: '共',
    numberOfPrizes2: '份',
    receiveByScanCode: '领取奖品',
    receiveByFillInformation: '填写中奖信息',
    participationConditions: '参与条件',
    winTitle: '恭喜您中奖啦',
    questionWinTitle: '恭喜抽中「{prize}」',
    notWinTitle: '很遗憾，没有中奖',
    pressToIdentifyCode: '长按识别二维码',
    joinCounts: '人参与',
    winCounts: '人中奖',
    winnerList: '中奖名单',
    scanToParticipate: '微信扫一扫，立即参与活动',
    copyLiveLink: '复制直播链接',
    participated: '您已参与，等待开奖中',
    scanningToParticipate: '微信扫码参与抽奖',
    invite: '邀请',
    invite1: '人即可参与，',
    invite2: '还需邀请',
    invite3: '人',
    metConditions: '你已满足参与条件',
    participateNow: '立即参与抽奖',
    copyLinkToParticipate: '复制链接到微信参与活动',
    noRecord: '暂无中奖记录~',
    opened: '已开奖',
    noWinnerList: '暂无中奖名单~',
    requiredText: '(必填)',
    watch: '观看',
    watch1: '分钟即可参与，',
    watch2: '还需观看',
    watch3: '分钟(离开页面不计时)',
    watch4: '抽奖开始后观看满',
    notEligible: '您达不到抽奖条件，请期待更多福利',
    keepWatching: '继续观看',
    surplus: '还剩:',
    satisfied: '已满足',

    commentLabel: '互动区发送评论：',
    sendComment: '发送评论',
    sendCommentSuccess: '已为您自动发送评论',
    going: '进行中',
    total: '共',
    answerRight: '答对',
    questionConditionLabel1: '题',
    questionConditionLabel2: '题及以上可参与',
    starQuestion: '开始答题',
    continueQuestion: '继续答题',
    finishQuestion: '已完成答题，等待开奖中',
    finishQuestionProcess: '已完成{questionRate}题',
    questionsProcessTip1: '问题{questionRate}',
    questionsProcessTip2: '（答对{leastCount}题可抽奖，已答对{rightCount}题）',
    answerSubmit: '提交',
    nextQuestion: '下一题',
    answerRightMsg: '恭喜答对了',
    answerErrorMsg: '很遗憾答错了',
    answerMoreRight: '再答对{count}题即可参与抽奖',
    answersNumber: '{answers}人已答题，共{answerRight}人答对',
    waitSendQuestion: '等待题目推送中…',
    readyNextQuestion: '正在跳转下一题…',
    findAllQuestion: '已完成全部作答，正在统计结果…',
    readResultTotal: '查看统计结果',
    readPrize: '我知道了',
    satisfiesLotteryTip: '恭喜答对{count}题，获得抽奖资格',
    noSatisfiesLotteryTip: '很遗憾只答对{count}题，错失抽奖机会',
    questionLabel: '题目',
    lotteryQuestion: '福利答题',
    hasNewQuestionCome: '有新题目来啦，请前往答题',
    selectAnswerTip: '请选择答案',

    singleChoice: '【单选】',
    multiChoice: '【多选】',
    askQuestion: '【问答】',
    evaluate: '【评价】',
    judgement: '【判断】',
  },
};

const en = {
  welfareLottery: {
    copySuccess: 'Success',
    fillInformation: 'To ensure the prize reaches you, we require your personal information, please fill it in accurately.',
    deadlineFillInformation: 'To ensure the prize reaches you, we require your personal information, please fill it in accurately. Deadline: <span style="color: #FF5722">{date}</span>.',
    deadlineTip: 'You have exceeded the expiry date for filling in your contact information\n',
    receivedInformation: 'submit information successfully!  A staff will contact you later',
    submit: 'ensure',
    name: 'name',
    realName: 'Please enter your real name',
    phone: 'phone',
    enterPhone: 'Please enter your mobile phone number',
    wrongName: 'Please enter your name',
    wrongPhone: 'Wrong mobile phone number',
    countdownTip1: 'And',
    countdownTip2: 'lottery',
    record: 'Winning record',
    redemptionCode: 'Redemption code',
    winningTime: 'Winning time',
    see: 'Check',
    receive: 'Receive',
    winningResult: 'Result',
    resultTip1: 'Keep watching to win more benefits~',
    receivePrizes: 'prize collection',
    ok: 'OK',
    numberOfPrizes1: '',
    numberOfPrizes2: 'total',
    receiveByScanCode: 'Scan the code to receive the award',
    receiveByFillInformation: 'Fill in the winning information',
    participationConditions: 'Participation conditions',
    winTitle: 'Congratulations on your winning',
    questionWinTitle: 'Congratulations on「{prize}」',
    notWinTitle: 'Sorry, you did\'t win',
    pressToIdentifyCode: 'Long press to identify the QR code',
    joinCounts: 'participants',
    winCounts: 'winners',
    winnerList: 'List of winners',
    scanToParticipate: 'Scan to participate in activities',
    copyLiveLink: 'Copy live link',
    participated: 'Participated, waiting for the draw',
    scanningToParticipate: 'WeChat scan code to participate in the lottery',
    invite: 'invite',
    invite1: 'people to participate,',
    invite2: 'and ',
    invite3: ' more need to be invited',
    metConditions: 'You have met the conditions to participate',
    participateNow: 'Participate in the draw now',
    copyLinkToParticipate: 'Copy the link and go to WeChat to participate',
    noRecord: 'No winning record~',
    opened: 'Opened',
    noWinnerList: 'No winner list yet~',
    requiredText: '(Required)',
    watch: 'Watch',
    watch1: 'minutes to participate,',
    watch2: 'and you need to watch',
    watch3: ' minutes after the lottery starts(leave the page without time)',
    watch4: 'Watch for ',
    notEligible: 'You are not eligible',
    keepWatching: 'keep watching',
    surplus: 'remaining',
    satisfied: 'Eligible',

    commentLabel: 'Send a comment：',
    sendComment: 'send a comment',
    sendCommentSuccess: 'A comment has been automatically sent for you',
    going: 'In progress',
    total: 'Total',
    answerRight: 'Answer right',
    questionConditionLabel1: 'question',
    questionConditionLabel2: 'The question and above can participate',
    starQuestion: 'Start answering the question',
    continueQuestion: 'Continue to answer the question',
    finishQuestion: 'Completed, waiting for the draw',
    finishQuestionProcess: 'Completed {questionRate} question',
    questionsProcessTip1: 'Question {questionRate}',
    questionsProcessTip2: ' (answering {leastCount} questions correctly can draw prizes, and answering {rightCount} questions correctly)',
    answerSubmit: 'Submit',
    nextQuestion: 'Next question',
    answerRightMsg: 'Congratulations for getting the answer right',
    answerErrorMsg: 'Unfortunately wrong answer',
    answerMoreRight: 'Answer the {count} questions correctly to participate in the lottery',
    answersNumber: '{answers} people have answered questions, {answerRight} people answered right',
    waitSendQuestion: 'Waiting for the question to be pushed…',
    readyNextQuestion: 'Jumping to the next question…',
    findAllQuestion: 'All answers have been completed, and the results are being counted…',
    readResultTotal: 'View statistical results',
    readPrize: 'I see',
    satisfiesLotteryTip: 'Congratulations on answering the {count} questions correctly and qualifying for the lottery',
    noSatisfiesLotteryTip: 'Unfortunately, I only answered the {count} questions correctly and missed the chance to draw the lottery',
    questionLabel: 'Question',
    lotteryQuestion: 'Welfare Questions',
    hasNewQuestionCome: 'A new question is coming, please go to answer',
    selectAnswerTip: 'Please select an answer',

    singleChoice: '【Single Choice】',
    multiChoice: '【Multiple Choice】',
    askQuestion: '【Question】',
    evaluate: '【Evaluation】',
    judgement: '【Judgement】',
  },
};

export default {
  zh_CN: zhCN,
  en,
};
